"use strict";
/**
 * Returns an array with exceptions for the sentence beginning researcher.
 * @returns {Array} The array filled with exceptions.
 */

module.exports = function () {
    return [
    // Definite articles:
    "il", "lo", "la", "i", "gli", "le",
    // Indefinite articles:
    "uno", "un", "una",
    // Numbers 1-10 ('uno' is already included above):
    "due", "tre", "quattro", "cinque", "sei", "sette", "otto", "nove", "dieci",
    // Demonstrative pronouns:
    "questo", "questa", "quello", "quella", "questi", "queste", "quelli", "quelle", "codesto", "codesti", "codesta", "codeste"];
};
//# sourceMappingURL=firstWordExceptions.js.map
//# sourceMappingURL=firstWordExceptions.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/yoastseo/js/researches/italian/firstWordExceptions.js
// module id = 460
// module chunks = 0